// import LocalizedStrings from 'react-localization';
import { getStrings } from '../../Common/Localization/commonStrings';

const localizedStrings = {
  myAccountContainer: {
    strings: { en: {}, es: {}},
    common: ['globalError']
  },
  singleAccountComponent:{
    strings: {
      en: {
        viewBillErr: 'Please be aware that enrolling in Paperless billing will stop paper from being sent to your company\'s Accounts Payable location or payment agent.\n\nPlease be sure that this change has been approved by the person responsible for paying your company\'s bill prior to enrolling.',
        billUnavailableErr: 'Your bill is not available at this time.',
        billObInEligibleErr: 'This account is ineligible because it is already signed up for Paperless Billing with another user.',
        oBIneligible: 'ObIneligible',
        oBEnroll: 'ObEnroll',        
        oPIneligible: 'OpIneligible',
        dPIneligible:'DpIneligible',
        dPDeEnroll: 'DpDeEnroll',
        oPDeEnroll: 'OpDeEnroll',
        payNowSingleAccErr: 'This account is currently signed up for Auto Pay and will need to be cancelled in order to complete your sign up for Online Payment.\n\nDo you want to continue with sign up?',
        flag_Y: 'Y',
        yes_IWantToContinue: 'Yes, I want to continue',
        no_notAtThisTime: 'No, not at this time',
        customerAccountData: 'customerAccountData',
        customerAccountType: 'customerAccountType',
        billUnavailableErr1: 'If you’re enrolled in Online Billing notifications, we’ll email you as soon as the bill PDF is ready to view or download. Otherwise, please try again later.',
        billUnavailableErr1Header: 'Bill not yet available',
        billUnavailableErr2Header: 'Bill temporarily unavailable',
        billUnavailableErr2: 'Due to a technical issue, your bill PDF can’t be viewed or downloaded at the moment. We’re working to fix this as quickly as possible.',
        openText1: 'Open Text_1',
        openText100: 'Open Text_100',
        openText200: 'Open Text_200',
        openText250: 'Open Text_250',
        openText700: 'Open Text_700',
        openText800: 'Open Text_800',
        openText900: 'Open Text_900',
        openText1000: 'Open Text_1000',
        openText2000: 'Open Text_2000',
        openText3000: 'Open Text_3000',
        active:'Active',
        inActive:'Inactive',
        pending:'Pending',
        accountStatus:'Account Status: '
       },
      es: {"billUnavailableErr": "Su factura no está disponible en este momento.", "billUnavailableErr1": "Su factura aún no está disponible. Si está inscrito en las notificaciones de facturación en línea, le enviaremos un correo electrónico cuando esté lista. De lo contrario, intente nuevamente más tarde.", "billUnavailableErr2": "Lo sentimos, pero debido a un problema del sistema, su factura no está disponible temporalmente para su visualización. Estamos trabajando para resolver el problema lo antes posible. Por favor, intente nuevamente más tarde. Código de error"},
      ko: {"billUnavailableErr": "현재 청구서를 사용할 수 없습니다.", "billUnavailableErr1": "청구서가 아직 준비되지 않았습니다. 온라인 청구 알림에 등록되어 있으면 준비되었을 때 이메일을 보내드리겠습니다. 그렇지 않으면 나중에 다시 시도해 주세요.", "billUnavailableErr2": "시스템 문제로 인해 청구서를 일시적으로 볼 수 없습니다. 문제를 최대한 빨리 해결하기 위해 노력하고 있습니다. 나중에 다시 시도해 주세요. 오류 코드"},
      vi: {"billUnavailableErr": "Hóa đơn của bạn hiện không có sẵn.", "billUnavailableErr1": "Hóa đơn của bạn chưa có sẵn. Nếu bạn đã đăng ký thông báo Hóa đơn Trực tuyến, chúng tôi sẽ gửi email cho bạn khi hóa đơn sẵn sàng. Nếu không, vui lòng thử lại sau.", "billUnavailableErr2": "Chúng tôi xin lỗi, nhưng do sự cố hệ thống, hóa đơn của bạn tạm thời không thể xem được. Chúng tôi đang cố gắng giải quyết vấn đề sớm nhất có thể. Vui lòng thử lại sau. Mã lỗi"},
      zh: {"billUnavailableErr": "您的账单目前不可用。", "billUnavailableErr1": "您的账单尚未准备好。如果您已注册在线账单通知，我们会在账单准备好时发送电子邮件给您。否则，请稍后再试。", "billUnavailableErr2": "很抱歉，由于系统问题，您的账单暂时无法查看。我们正在努力尽快解决问题。请稍后再试。错误代码"}
    },
    common: ['yes', 'no']
  },
  billingOverviewComponent: {
    strings: {
      en: {
        bannerMessage: 'My Account Overview',
        billHeading: 'Your Bill',
        amountDue: 'Balance Due:',
        dueDate: 'Date Due:',
        moreWaysToPay: 'More Ways to Pay',
        nemCurrMonthLabel: 'You are in month ',
        nemCurrMonthLabel2: ' of ',
        nemYearToDateCharges: 'Year to Date ',
        nemYearToDateCharges2: 'Charges: ',
        nemDueLabel: ' Due: ',
        payNowBtn: 'Pay Now',
        viewBillBtn: 'View Bill',
        downloadBillBtnLabel: 'Download PDF Bill',
        sceAccountRepBtn: 'SCE Account Rep',
        nextBillLabel: 'Your next bill will be available on or about ',
        seeBillInsertsLink: 'See Bill Inserts',
        viewUsageBtn: 'View Usage',
        viewManageBtn: 'View/Manage Accounts',
        goToBnPBtn: 'Go to Billing & Payments',
        enrollInDigitalNotificationsBtn:'Enroll in Digital Notifications',
        trackedEnergyAmt: 'Tracked Energy Amount: $',	
        NEMMsg2: ' of your relevant period',	
        autoPayEnrolledLabel: 'You are currently enrolled in Auto Pay',
        depositAccMsg: 'The customer account registered is a Deposit Account. To view your account balance and make payment, ',
        clickHereLink: 'click here',
        depositAccMsg1: '. If you have other accounts with us, you can go to ',
        depositAccMsg2: ' to add them to your account view.',
        /************************
        Change type : No.of accounts message change in Single Account and Multi account view
        Changed by: Jitendra D
        Date : 30-06-2020
        ************************/
        noOfAccountsDisplayed: ' accounts displayed. Select View/Manage Accounts to add or remove accounts to your My Account Overview page.',
        pendingtxt: 'You have a pending payment,',
        edit: 'edit'
      },
      es: {}
    },
    common: []
  },
  nemDialogComponent: {
    strings: {
      en: {
        nemHeaderLabel: 'What is the year-to-date energy charge?',
        nemParaOneText: 'When you have a Net Energy Metering (NEM) account with Annual Payment Option, you don’t pay for your energy charges each month. This is because some months, you receive energy credits when you generate more energy than you use.',
        nemParaTwoText: 'The year-to-date charge is the balance of those credits and charges. At the end of your 12-month billing period, you’ll receive a settlement bill for that balance.',
        nemDialogClose: 'Close',
        requestPaymentArrangement: 'Request Payment Arrangement',
        underStandMyBill:'Understand My Bill',
        billsFAQs:'Billing & Payments FAQs',
        howCanHelptext:'How Can We Help You?',
        FindTopictext:'Find a topic below',
        NeedHelpText:'Need More Help? Ask SCE',
        askSce:'ASK SCE',
        askLink:'https://ask.sce.com/'
      },
      es: {}
    },
    common: []
  },
  serviceAccountComponent: {
    strings: {
      en: {
        serviceAccHeading: 'Service Account: ',
        serviceAccHeadingPopUp: 'Service Account',
        serviceAccHeading2: 'Service Address',
        serviceAccHeading3: ' Service Accounts | Select an account:',
        ratePlan: 'Your Rate Plan: ',
        ratePlanTitle: 'Rate Plan: ',
        ratePlanTitlePopUp: 'Rate Plan',
        statusTitle: 'Status: ',
        compareRatePlanText: 'Not sure you\'re on the right plan? ',
        compareRatePlanLink: 'Compare Rate Plans ',
        projectedBillHeader: 'Projected Next Bill',
        projectedBillNEMHeader: 'Projected Energy Charges',
        projectedBillBAIneligibleHeader: 'Projected Energy Usage',
        projectedChargesWithBA: ' with Budget Assistant',
        viewUsage: 'View usage by energy tier:',
        viewUsageTier: ' Usage Per Tier',
        viewBilledUsageTier: ' Billed Usage Per Tier',
        viewBilledUsageTOU: ' Billed Usage Per TOU',
        viewUsageTOU: ' Usage Per TOU',
        summerPlan: 'Summer Discount Plan',
        summerPlanText: 'Earn bill credits on your energy bill with Summer Discount Plan. Flexible program options let you choose your level of comfort and savings.',
        learnMore: 'Learn More ',
        helpPayingBill: 'More Help With Your Bill',
        helpPayingBillText: 'See all of your options for managing difficult bills, including payment arrangements, public assistance, and more.',
        delayedBillingMsg: 'Due to a delay in your account billing, your usage details will not be available.',
        tryAgain: ' Please try again later.',
        noUsageData: 'Your Projected Next Bill calculations are currently unavailable.',
        viewProjectedUsageLink: 'View Projected Usage ',
        active:'Active', inActive:'Inactive',
        pending:'Pending', customerAccount: 'Customer Account', customerName: 'Customer Name',
        accountStatus:'Account Status: ', accountStatusPopUp:'Account Status',
        href:'javascript:;', mailingAddress: 'Mailing Address',
        moveInDate:'Move In Date:',
        moveOutDate:'Move Out Date:', rotatingOutage: 'Rotating Outage Group',
        projectBillNBTError:'Projected Next Bill data is temporarily unavailable. Please check back soon.',
        serviceAccountDetails: 'Service Account Details', popIdInfoPopUp:'This is an additional customer identification field for your reference for your billing inquiries. The POD ID can also be located near your Service Account number on your bill.', rogInfoPopUp: 'Rotating Outages help avoid widespread or uncontrolled blackouts during system emergencies. SCE accounts in groups A, M, R, S and X are subject to rotating outages. Group can change, without notice, at any time.',
      },
      es: {
        serviceAccHeading2: 'Dirección del Servicio', rogInfoPopUp: 'Los apagones rotativos ayudan a evitar apagones generalizados o descontrolados durante emergencias del sistema. Las cuentas de SCE en los grupos A, M, R, S y X están sujetas a apagones rotativos. El grupo puede cambiar, sin previo aviso, en cualquier momento.',
        serviceAccHeading3: 'Cuentas de Servicio | Seleccione una cuenta:',
        serviceAccHeading: 'Cuenta de Servicio: ', customerAccount: 'Cuenta de Cliente',
        customerName: 'Nombre del Cliente', compareRatePlanLink: 'Comparar Planes de Tarifas',
        serviceAccHeadingPopUp: 'Cuenta de Servicio', mailingAddress: 'Dirección Postal',
        ratePlanTitle: 'Plan de Tarifas: ', rotatingOutage: 'Grupo de Corte Rotativo',
        ratePlanTitlePopUp: 'Plan de Tarifas', moveInDate: 'Fecha de Mudanza:',
        statusTitle: 'Estado: ', accountStatusPopUp: 'Estado de la Cuenta',
        serviceAccountDetails: 'Detalles de la Cuenta de Servicio', popIdInfoPopUp: 'Este es un campo de identificación adicional del cliente para su referencia en sus consultas de facturación. El ID de POD también se puede encontrar cerca de su número de cuenta de servicio en su factura.',
      },
      zh: {
        serviceAccHeading2: '服务地址', rogInfoPopUp: '轮流停电有助于在系统紧急情况下避免大范围或失控的停电。SCE 账户在 A、M、R、S 和 X 组中会受到轮流停电的影响。组别可能会在任何时候不经通知地更改。',
        serviceAccHeading3: '服务账户 | 选择一个账户:', customerName: '客户姓名',
        serviceAccHeading: '服务账户: ', customerAccount: '客户账户',
        serviceAccHeadingPopUp: '服务账户', mailingAddress: '邮寄地址',
        ratePlanTitle: '费率计划: ', rotatingOutage: '轮流停电组',
        ratePlanTitlePopUp: '费率计划', moveInDate: '入住日期:',
        statusTitle: '状态: ', accountStatusPopUp: '账户状态',
        serviceAccountDetails: '服务账户详情', compareRatePlanLink: '比较费率计划', popIdInfoPopUp: '这是一个额外的客户识别字段，供您在账单查询时参考。POD ID 也可以在您的账单上的服务账号号码附近找到。',
      },
      ko: {
        serviceAccHeading2: '서비스 주소', rogInfoPopUp: '순환 정전은 시스템 비상 상황에서 광범위하거나 통제되지 않은 정전을 방지하는 데 도움이 됩니다. SCE 계정 중 A, M, R, S 및 X 그룹은 순환 정전의 대상이 됩니다. 그룹은 사전 통보 없이 언제든지 변경될 수 있습니다.',
        serviceAccHeading3: '서비스 계정 | 계정을 선택하세요:', customerName: '고객 이름',
        serviceAccHeading: '서비스 계정: ', customerAccount: '고객 계정',
        serviceAccHeadingPopUp: '서비스 계정', mailingAddress: '우편 주소',
        ratePlanTitle: '요금제: ', rotatingOutage: '순환 정전 그룹',
        ratePlanTitlePopUp: '요금제', moveInDate: '입주 날짜:',
        statusTitle: '상태: ', accountStatusPopUp: '계정 상태',
        serviceAccountDetails: '서비스 계정 세부 정보', compareRatePlanLink: '요금제 비교',popIdInfoPopUp: '이것은 청구 문의를 위한 참조용 추가 고객 식별 필드입니다. POD ID는 청구서의 서비스 계정 번호 근처에서도 찾을 수 있습니다.',
      },
      vi: {
        serviceAccHeading2: 'Địa chỉ Dịch vụ', rogInfoPopUp: 'Các đợt cắt điện luân phiên giúp tránh các sự cố mất điện trên diện rộng hoặc không kiểm soát được trong các tình huống khẩn cấp của hệ thống. Các tài khoản SCE trong các nhóm A, M, R, S và X sẽ phải chịu các đợt cắt điện luân phiên. Nhóm có thể thay đổi mà không cần thông báo trước vào bất kỳ lúc nào.',
        serviceAccHeading3: 'Tài khoản Dịch vụ | Chọn một tài khoản:', customerName: 'Tên Khách hàng',
        serviceAccHeading: 'Tài khoản Dịch vụ: ', customerAccount: 'Tài khoản Khách hàng',
        serviceAccHeadingPopUp: 'Tài khoản Dịch vụ', mailingAddress: 'Địa chỉ Thư',
        ratePlanTitle: 'Kế hoạch Giá: ', rotatingOutage: 'Nhóm Cúp Điện Luân Phiên',
        ratePlanTitlePopUp: 'Kế hoạch Giá', moveInDate: 'Ngày Chuyển vào:',
        statusTitle: 'Trạng thái: ', accountStatusPopUp: 'Trạng thái Tài khoản',
        serviceAccountDetails: 'Chi tiết Tài khoản Dịch vụ', compareRatePlanLink: 'So sánh Các Gói Cước', popIdInfoPopUp: 'Đây là một trường nhận dạng khách hàng bổ sung để bạn tham khảo cho các yêu cầu thanh toán của mình. Mã POD cũng có thể được tìm thấy gần số Tài khoản Dịch vụ trên hóa đơn của bạn.',
      }      
    }, common: []
  }
};

export const getLocalizedStrings = (componentName) => { 
  // app.logger.getLogger().info('Comp Name' + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
  // return new LocalizedStrings(strings);
};
